<template>
  <div>

    <error-dialog :status="saveStatus" />

    <sign-in-dialog ref="sign-in" v-model="showSignInDialog">
      <template slot="subtitle">
        Sign in to accept our <a href="/terms-and-conditions">terms and conditions</a> and link this card with your account
      </template>
    </sign-in-dialog>

    <v-container>
      <h1 class="mt-6 text-h4 text-sm-h3 header-font">Create a reusable group card design</h1>
      <div class="mt-3 mb-12">Add a cover image or short animated video / GIF, and we'll store the design in your account. You can also share it with others so that they can send cards using your cover design.</div>

      <card-file-input class="mx-auto" style="max-width: min(50%, 360px);" @input="x => toSave = x" />

      <div class="text-center py-6">
        <v-btn color="primary" :disabled="!toSave" :loading="saveStatus.pending" @click="save">Save</v-btn>
      </div>

      <h2 class="pt-6 text-h5">Tips</h2>
      <ul>
        <li>You can use any image or video file format that your browser can read, like JPEG, PNG, GIF, or MP4.</li>
        <li>Maximum file size is limited to 10 MB.</li>
        <li>Images / videos will be automatically cropped to fill our 5x7 cards. For the best quality possible, use a resolution of at least 600x840.</li>
        <li>Your files will be automatically compressed / transcoded – please double-check the final version from your Ellacard account</li>
      </ul>

      <h2 class="text-h5 pt-6">Monetizing your designs</h2>
      <p>Want to sell your designs on Ellacard? Check out our <router-link :to="{ name: 'design' }">design portal</router-link> to get started.</p>

    </v-container>
  </div>
</template>


<script>
import CardFileInput from '@/components/CardFileInput.vue';
import SignInDialog from '@/components/SignInDialog.vue';


export default {
  name: 'img-to-design',

  routerViewMeta: {
    title: 'Image to design',
    description: 'Convert any image into a reusable Ellacard design'
  },

  components: {
    CardFileInput,
    SignInDialog
  },

  data() {
    return {
      showSignInDialog: false,
      toSave: null,
      saveStatus: this.$track('save')
    }
  },

  methods: {
    async save() {
      if (!this.isSignedIn) {
        await this.$refs['sign-in'].prompt();
        if (!this.isSignedIn)
          return;
        await this.$nextTick();
      }

      const { w, h, url, isAnimated } = this.toSave;
      const file = await fetch(url).then(r => r.blob());
      await this.$call('create-design-from-file', { file, w, h, block: true, post_process: isAnimated });
      this.$router.push({ name: 'account-design-cards' });
    }
  }
}
</script>
